import React from "react";
import { saveAs } from 'file-saver';
import { toBlob } from 'html-to-image';
import { useSelector } from 'react-redux'
import CreativeNameDisplay from "../shared/CreativeNameDisplay"
function FullImagePreview({ preview }) {
  const handleClick = () => { };
  const componentId = useSelector(state => state.Head.component_id)

  const handleDownloadPreview = () => {
    const previewElement = document.querySelector('.download-preview');
    toBlob(previewElement).then(function (blob) {
      saveAs(blob, `${preview.name}.png`);
    });
  };
  return (
    <>
      <div className="flex mb-5">

        {componentId === 6 ? <div className="justify-end">
          <sl-icon-button
            library="lucide"
            name="download"
            onClick={handleDownloadPreview}
          ></sl-icon-button>
        </div> : null}
      </div>
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />
        <div className="preview-inner">
          <div className="preview-full-image">
            {preview.img_urls && <img src={preview.img_urls} alt="" className={`w-full ${preview.button_enabled ? '!h-[90%] mb-1' : '!h-[95%]'}`} />}
            {preview.button_enabled ? <div className="w-full d-flex justify-center">
              <button style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr }} className={`rounded px-3 py-1`} onClick={handleClick}>{preview.button_text}</button>
            </div> : null}
            <img src="https://d30365bzukh5e5.cloudfront.net/share_content_imgs/telugu_new3_v8.png" alt="way2news-logo" />
          </div>
        </div>
      </div>
    </>
  );
}

export default FullImagePreview;
